<template>
  <div v-if="showBanner">
    <!-- Not certified -->
    <PAlert
      v-if="certification.status === 'not_certified'"
      color="warning"
      class="d-flex align-items-center justify-content-between mb-4"
    >
      <div>
        <strong v-translate translate-context="payout.certification">
          Complete your company certification
        </strong>
        <span class="ml-1" v-translate translate-context="payout.certification">
         Enter your VAT number or upload a document certifying the existence of your company (it will be approved after 48 hours).
        </span>
      </div>
      <template #cta>
        <CButton
          color="warning"
          variant="outline"
          size="sm"
          class="ml-3 text-nowrap"
          @click="$emit('open-certification')"
        >
          <translate translate-context="payout.certification">Complete now</translate>
          <CIcon name="cipExternalLink" size="sm" class="ml-1"/>
        </CButton>
      </template>
    </PAlert>

    <!-- Pending -->
    <CAlert
      v-else-if="certification.status === 'pending'"
      color="info"
    >
      <translate translate-context="payout.certification">
        Company certification in progress — as soon as it is confirmed you will be able to upload invoices to receive
        your payments
      </translate>
    </CAlert>

    <!-- Rejected -->
    <CAlert
      v-else-if="certification.status === 'rejected'"
      color="warning"
      class="d-flex align-items-center justify-content-between"
    >
      <div>
        <strong v-translate translate-context="payout.certification">
          Certification request rejected
        </strong>
        <span v-if="certification.rejected_reason" class="ml-1">
          — {{ certification.rejected_reason }}
        </span>
      </div>
      <CButton
        color="warning"
        variant="outline"
        size="sm"
        class="ml-3 text-nowrap"
        @click="$emit('open-certification')"
      >
        <translate translate-context="payout.certification">Retry</translate>
      </CButton>
    </CAlert>
  </div>
</template>

<script>
import {CERTIFICATION_STATUS} from '../constants'
import PAlert from "@/components/PAlert.vue";

export default {
  name: 'CertificationBanner',
  components: {PAlert},
  props: {
    certification: {
      type: Object,
      required: true
    }
  },
  computed: {
    showBanner() {
      return this.certification.status !== CERTIFICATION_STATUS.CERTIFIED
    }
  }
}
</script>
